import ColumnScrollCode from "!!raw-loader!./gridcolumns/ColumnScroll";
import ColumnNoScrollCode from "!!raw-loader!./gridcolumns/ColumnNoScroll";
import ColumnSpacingAroundCode from "!!raw-loader!./gridcolumns/ColumnSpacingAround";
import ColumnSpacingAroundYAxisCode from "!!raw-loader!./gridcolumns/ColumnSpacingAroundYAxis";
import ColumnSpacingAroundXAxisCode from "!!raw-loader!./gridcolumns/ColumnSpacingAroundXAxis";
import ColumnWithBorderCode from "!!raw-loader!./gridcolumns/ColumnWithBorder";
import React from "react";
import { ComponentProps } from "../Component";
import Pane, { paneComponent, PaneProps } from "../Pane";
import ColumnScroll from "./gridcolumns/ColumnScroll";
import ColumnNoScroll from "./gridcolumns/ColumnNoScroll";
import ColumnSpacingAround from "./gridcolumns/ColumnSpacingAround";
import ColumnSpacingAroundYAxis from "./gridcolumns/ColumnSpacingAroundYAxis";
import ColumnSpacingAroundXAxis from "./gridcolumns/ColumnSpacingAroundXAxis";
import ColumnWithBorder from "./gridcolumns/ColumnWithBorder";

export default (props: PaneProps) => {
	const components: ComponentProps[] = [
		paneComponent("SpacingAround Example", ColumnSpacingAroundCode, ColumnSpacingAround),
		paneComponent("SpacingAround X-Axis Example", ColumnSpacingAroundXAxisCode, ColumnSpacingAroundXAxis),
		paneComponent("SpacingAround Y-Axis Example", ColumnSpacingAroundYAxisCode, ColumnSpacingAroundYAxis),
		paneComponent("Scrolling Example Scroll Property off", ColumnNoScrollCode, ColumnNoScroll),
		paneComponent("Scrolling Example Scroll Property on", ColumnScrollCode, ColumnScroll),
		paneComponent("StandardBorder Example", ColumnWithBorderCode, ColumnWithBorder),
	];

	return (
		<Pane
			components={components}
			{...props}
		/>
	);
};